<template>
  <div class="login-wrap">
    <template v-if="token || loginType">
      <div class="auto-login">
        <span v-if="!autoLoginFail">自动登录中</span>
        <button @click="tryAutoLogin" v-else>点击返回上一页面进行重试</button>
      </div>
    </template>
    <template v-else>
      <div class="text-center">
        <div class="icon-logo-wrap">
          <img class="icon-logo" src="./img/new_logo.png">
        </div>
      </div>
      <div class="login-form">
        <div class="form-item">
          <input type="number" placeholder="请输入手机号码" v-model="loginTel">
        </div>
        <div class="form-item">
          <input type="number" placeholder="请输入短信验证码" v-model="loginSmsCode">
          <button :disabled="isGetSmsCodeButtonDisabled" @click="doGetCode">
            <template v-if="isCounting">{{ count }}s后重新获取</template>
            <template v-else>获取验证码</template>
          </button>
        </div>
        <hCheckBox class="col-expires" v-model="isLoginExpiresChecked">15天免登陆</hCheckBox>
        <hButton
          class="submit-button"
          size="large"
          type="primary"
          :disabled="isSubmitLoginDisabled"
          @click="doLogin"
        >登录</hButton>
      </div>
      <p class="login-tip">
        <img src="./img/login_icon_tips@2x.png">
        <span>若未注册回收宝账号，将自动注册回收宝账号</span>
      </p>
    </template>
  </div>
</template>

<script>
import parse from 'url-parse';
import { Toast } from 'mint-ui';
import hButton from '@/components/button';
import hCheckBox from '@/components/checkbox';
import loadScript from '@/helper/loadscript';
import { login, getCaptchaCode, getUserInfo, updateUserTel, loginByYoupin } from '@/apis/base';
import { checkLoginStatus } from '@/apis/hsbh5';
import { isInHsbApp, hsbApp } from '../../projects/hsbh5/utils/hsbApp';
import { captchaAppId } from '@/config';

const SEC = 90;
const checkedDay = 30;
const unCheckedDay = 15;

export default {
  components: {
    hButton,
    hCheckBox
  },
  data () {
    return {
      loginCodeTimeId: null,
      loginTel: '',
      loginSmsCode: '',
      loginExpires: checkedDay,
      count: SEC,
      isLoginExpiresChecked: true,
      autoLoginFail: false,
      randstr: '',
      ticket: ''
    };
  },
  computed: {
    isInHsbApp () {
      return isInHsbApp();
    },
    isTelValid () {
      return this.loginTel.length === 11;
    },
    isGetSmsCodeButtonDisabled () {
      return !this.isTelValid || this.isCounting;
    },
    isSubmitLoginDisabled () {
      return !this.isSmsCodeValid || !this.isSmsCodeValid;
    },
    isSmsCodeValid () {
      return this.loginSmsCode.length === 6;
    },
    isCounting () {
      return this.count !== SEC;
    },
    expires () {
      return this.isLoginExpiresChecked ? checkedDay : unCheckedDay;
    },
    redirect () {
      return this.$route.query.redirect;
    },
    auth2CallBack () {
      return window.encodeURIComponent(window.location.href);
    },
    // 只用于第三方登录回调
    token () {
      return this.$route.query.token;
    },
    loginType () {
      return this.$store.state.config.loginType;
    },
    auth2LoginUrl () {
      return this.$store.state.config.auth2LoginUrl;
    }
  },
  methods: {
    tryAutoLogin () {
      if (this.$route.query.locationUrl) {
        window.location.href = this.$route.query.locationUrl;
      } else {
        this.$router.replace(this.redirect || '/');
      }
    },
    startCount () {
      this.count--;
      this.loginCodeTimeId = setTimeout(() => {
        if (this.count === 0) {
          this.count = SEC;
          return;
        }
        this.startCount();
      }, 1000);
    },
    async doGetCode () {
      if (!this.randstr || !this.ticket) {
        return this.showCaptcha();
      }
      try {
        const result = await getCaptchaCode({
          tel: this.loginTel,
          randstr: this.randstr,
          ticket: this.ticket
        });
        if (result._errCode === '0') {
          Toast('短信已发送');
          this.randstr = '';
          this.ticket = '';
          this.startCount();
        } else {
          Toast(result._errStr || '短信发送失败，稍后重试');
        }
      } catch (err) {
        Toast('短信发送失败');
      }
    },
    showCaptcha () {
      try {
        const captcha = new window.TencentCaptcha(captchaAppId, this.captchaVerify);
        captcha.show();
      } catch (error) {
        this.captchaVerify({
          ret: 0,
          randstr: `@${Math.random().toString(36).slice(2)}`,
          ticket: `trerror_1001_${captchaAppId}_${Math.floor(new Date().getTime() / 1000)}`,
          errorCode: 1001,
          errorMessage: 'jsload_error'
        });
      }
    },
    captchaVerify (result) {
      const { ret, randstr, ticket } = result || {};
      if (ret === 0 && randstr && ticket) {
        this.randstr = randstr;
        this.ticket = ticket;
        this.doGetCode();
      }
    },
    async doLogin () {
      try {
        const result = await login(this.loginTel, this.loginSmsCode, this.expires);
        if (result._errCode !== '0') {
          Toast(result._errStr);
          return;
        }
        this.loginAfter(result._data.token, result._data);
      } catch (err) {
        Toast(err);
      }
    },
    async doUpdateTel () {
      try {
        const result = await updateUserTel({
          code: this.loginSmsCode,
          tel: this.loginTel
        });
        if (result._errCode !== '0') {
          Toast(result._errStr);
          return;
        }
        this.bindAfter(result._data.token, result._data);
      } catch (err) {
        Toast(err);
      }
    },
    getUserInfo (ntoken) {
      return getUserInfo(ntoken).then(res => {
        if (!res || +res._errCode !== 0 || !res._data) {
          return;
        }
        return res._data;
      });
    },
    bindAfter (token, userInfo) {
      if (userInfo) {
        this.loginTel = '';
        this.$store.commit('user/setUserInfo', {
          tel: userInfo.tel,
          openid: userInfo.openid,
          eid: userInfo.eid
        });
      }
      this.$store.commit('user/setToken', token, this.expires);
      this.$router.go(-1);
    },
    loginAfter (token, userInfo) {
      if (userInfo) {
        this.$store.commit('user/setUserInfo', {
          tel: userInfo.tel,
          openid: userInfo.openid,
          eid: userInfo.eid
        });
      }
      this.$store.commit('user/setToken', token, this.expires);
      console.log('this.$route.query: ', this.$route.query);
      if (this.$route.query.locationUrl) {
        window.location.href = this.$route.query.locationUrl;
      } else {
        const pid = this.$store.state.pid;
        if (+pid === 1597) {
          window.localStorage.setItem('yearToken', token);
        }
        if (isInHsbApp()) {
          this.$router.go(-1);
        } else {
          if (+pid === 1043) {
            console.log('this.redirect: ', this.redirect);
            let wxInfo = window.localStorage.getItem('wxInfo');
            const { fromPid, storeId, clerkId, event, openid, unionid, scene, tempNo, storeName, clerkName, cityId, cityName } = this.$route.query;
            const last = this.redirect.indexOf('?');
            if (wxInfo) {
              wxInfo = JSON.parse(wxInfo);
              if (openid) wxInfo.openid = openid;
              if (unionid) wxInfo.unionid = unionid;
              window.localStorage.setItem('wxInfo', JSON.stringify(wxInfo));
            } else {
              window.localStorage.setItem('wxInfo', JSON.stringify({
                openid: openid || '',
                unionid: unionid || ''
              }));
            }
            if (last !== -1) {
              const link = this.redirect.slice(0, last);
              let params = '';
              if (fromPid) params += `&fromPid=${fromPid}`;
              if (storeId) params += `&storeId=${storeId}`;
              if (clerkId) params += `&clerkId=${clerkId}`;
              if (event) params += `&event=${event}`;
              if (scene) params += `&scene=${scene}`;
              if (tempNo) params += `&tempNo=${tempNo}`;
              if (storeName) params += `&storeName=${storeName}`;
              if (clerkName) params += `&clerkName=${clerkName}`;
              if (cityId) params += `&cityId=${cityId}`;
              if (cityName) params += `&cityName=${cityName}`;
              this.$router.replace(`${link}?pid=1043&openId=${openid || ''}&unionId=${unionid || ''}${params}`);
            }
            return;
          }
          this.$router.replace(this.redirect || '/');
        }
      }
    },
    autoAutoLogin () {
      const that = this;
      if (+this.$store.state.pid === 1439) {
        loadScript('https://s1.huishoubao.com/colagoods/app/cola-sdk.2.3.8.js', () => {
          window.cola && window.cola.login().then(ret => {
            if (ret.token) {
              loginByYoupin({openId: ret.token}).then(res => {
                if (+res._errCode === 0) {
                  that.getUserInfo(res._data.token).then(userInfo => {
                    that.loginAfter(res._data.token, userInfo);
                  }).catch(error => {
                    throw new Error(error);
                  });
                } else {
                  Toast(res._errStr);
                }
              });
            } else {
              Toast(ret._errStr);
            }
          });
        });
        return false;
      }
      let loginUrl = `${this.auth2LoginUrl}?redirectUri=${this.auth2CallBack}&platform=${this.$store.state.config.platform}&pid=${this.$store.state.pid}&oauthSite=${this.loginType}`;

      /**
       * 微信授权登录
       * loginWay: 1 需要授权
       * loginWay：2 不需要授权
       */
      if (this.$store.state.config.loginType === 'wechat') loginUrl += '&loginWay=2';

      const urlObj = parse(loginUrl, true);
      if (this.authPrams) {
        Object.keys(this.authPrams).forEach(key => {
          urlObj.query[key] = this.authPrams[key];
        });
      }
      window.location.replace(urlObj.toString());
    },
    handleAppLogin () {
      const that = this;
      window.hsbAppLoginCallback = function (res) {
        if (!res) {
          return Toast('登录失败: 回调函数为空');
        }
        if (typeof res === 'string') {
          res = JSON.parse(res);
        }
        if (+res._errCode === 0) {
          that.getUserInfo(res._data.token).then(userInfo => {
            that.loginAfter(res._data.token, userInfo);
          }).catch(error => {
            throw new Error(error);
          });
        } else {
          Toast(res._errStr);
        }
      };
      try {
        hsbApp.hsbAppLogin({ callback: 'hsbAppLoginCallback' });
      } catch (error) {
        Toast(error);
      }
    },
    initLogin () {
      this.initHSBLogin();
    },
    async initHSBLogin () {
      const { redirect, platform } = this.$route.query;
      if (!this.token && (this.loginType || isInHsbApp() || +platform === 6 || +platform === 7)) {
        const pid = this.$store.state.pid;
        if (this.loginType === 'wxmp') {
          const url = window.location.href;
          const hsbUrl = 'https://mobile.huishoubao.com/hsbh5';
          if (url.indexOf(hsbUrl) !== -1 && +pid !== 1597) {
            let redirectRouter = redirect;
            if (redirectRouter.indexOf('?') !== -1) {
              redirectRouter = redirectRouter.split('?')[0];
            }
            const page = '/page/pages/coupon-get-h5/index';
            const fullLink = encodeURIComponent(`${hsbUrl}${redirectRouter}`);
            window.wx.miniProgram.redirectTo({
              url: `/page/pages/login/index?page=${page}=&webUrl=${fullLink}&isRedirect=1`
            });
          } else {
            Toast('登录已过期，请返回小程序登录');
          }
        } else if (isInHsbApp() || +platform === 6 || +platform === 7) {
          if (+pid !== 1597) {
            this.handleAppLogin();
          }
        } else {
          this.autoAutoLogin();
        }
      } else if (this.token) {
        let ret = await checkLoginStatus(this.token);
        if (+ret._errCode === 0) {
          if (+ret._data.status === 1) {
            this.getUserInfo(this.token).then(userInfo => {
              this.loginAfter(this.token, userInfo);
            }).catch(error => {
              Toast(`登录失败: ${error}`);
              this.autoLoginFail = true;
            });
          } else {
            // 传过来的登录态失效
            const pid = this.$store.state.pid;
            if (isInHsbApp() || +platform === 6 || +platform === 7) {
              if (+pid !== 1597) {
                this.handleAppLogin();
              }
            }
            if (this.loginType === 'wxmp') {
              Toast('登录已过期，请返回小程序登录');
            }
          }
        }
      }
    }
  },
  mounted () {
    this.initLogin();
  }
};
</script>

<style lang="postcss" scoped>
.login-wrap {
  height: 100vh;
  background-color: #fff;
  /deep/ .hsb-checkbox.is-checked {
    color: #949BA1;
  }
  /deep/ .hsb-checkbox__inner {
    width: 14px;
    height: 14px;
  }
  /deep/ .hsb-checkbox.is-checked .hsb-checkbox__inner {
    background-color: #FFDA05;
    border-color: #FFDA05;
  }
  /deep/ .hsb-checkbox__label {
    font-size: 12px;
  }
  /deep/ .hsb-button.is-disabled,
  /deep/ .hsb-button[disabled] {
    color: #C9CED1;
    background: #E7ECEE;
  }
  /deep/ .hsb-checkbox {
    color: #949BA1;
  }
}

.icon-logo-wrap {
  padding-top: 28px;
  padding-bottom: 48px;
}

.icon-logo {
  width: 98px;
  height: 98px;
}

.login-form {
  padding: 0 35px;
}

.form-item {
  display: flex;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #EFF2F3;
  input {
    flex: 1;
    line-height: 24px;
  }
}

.login-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  color: #949BA1;
  text-align: center;
  img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
}

.submit-button {
  margin-top: 30px;
  font-size: 16px;
  letter-spacing: 2px;
}

.col-expires {
  margin-top: 16px;
}

.auto-login {
  padding: 24px;
  color: #999;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/core/login/hsbLogin.vue